import { render, staticRenderFns } from "./CardFile.vue?vue&type=template&id=20972983"
import script from "./CardFile.vue?vue&type=script&lang=js"
export * from "./CardFile.vue?vue&type=script&lang=js"
import style0 from "./CardFile.vue?vue&type=style&index=0&id=20972983&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports